import { type TFunction } from "i18next";
import { type Option } from "~/molecules/ControlledCombobox";

export const NO_TIER_VALUE = "__no_tier__";

export const getNoTierLabel = (t: TFunction) =>
  t(($) => $.commons.document.noTierLabel);

export const getTierTitle = (title: string | null | undefined, t: TFunction) =>
  title ?? getNoTierLabel(t);

export const mapTierOptions = (
  tiers: { id: number; title: string }[] | undefined,
  t: TFunction,
): Option[] | undefined =>
  tiers
    ? [
        ...tiers.map((tier) => ({
          label: tier.title,
          value: tier.id.toString(),
        })),
        {
          label: "",
          value: `${NO_TIER_VALUE}_separator`,
          isSeparator: true,
        },
        {
          label: getNoTierLabel(t),
          value: NO_TIER_VALUE,
          subtitle: t(($) => $.commons.document.noTierDescription),
        },
      ]
    : undefined;

export const tierIdFormValueToNumberOrNull = (value: string) =>
  value === NO_TIER_VALUE ? null : Number(value);

export const tierIdToFormValue = (tierId: number | null | undefined) =>
  tierId == null ? NO_TIER_VALUE : tierId.toString();
